/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const Image = ({ width, height, fallbackSrc, src, ...props }) => {

   const [imageState, setImageState] = useState({
      src: '',
   });
    // eslint-disable-next-line camelcase
    useEffect(() => {
        setImageState({ ...imageState, src });
    }, []);

    const onError = (e) => {
        const errorImage = fallbackSrc
            || `data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">'
                + '<path fill="#CCC" d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>'
                + '</svg>')}`;
         e.target.src = errorImage 
    };

   // eslint-disable-next-line jsx-a11y/alt-text
   return <img src={imageState.src} onError={(e) => onError(e)} width={`${width}`} height={`${height}`} {...props} />; // eslint-disable-line react/jsx-props-no-spreading
}

Image.defaultProps = {
    src: '',
    fallbackSrc: '',
};

Image.propTypes = {
    src: PropTypes.string.isRequired,
    fallbackSrc: PropTypes.string,
};

export default Image;
